import EA from 'helpers/init';
import Swiper from 'swiper/swiper-bundle.esm.js';

export default EA.Methods.sliderSix = ($this) => {
    const slider = $this.querySelector('.swiper');
    const next = $this.querySelector('.swiper-button-next');
    const prev = $this.querySelector('.swiper-button-prev');
    const breakpoint = window.matchMedia('(max-width: 800px)');
    
    const swiper = new Swiper(slider, {
        allowTouchMove: true,
        loop: true,
        speed: 300,
        forceLoop: true,
        freeMode: true,
        spaceBetween: 8,
        watchSlidesProgress: true,
        navigation: {
            nextEl: next,
            prevEl: prev,
        },
        breakpoints: {
            320:  {
                spaceBetween: 8,
                slidesPerView: 1.5,
                allowTouchMove: true,
                touchRatio: 1,
            },
            801:  {
                spaceBetween: 8,
                slidesPerView: 3.5,

            },
            1001:  {
                spaceBetween: 20,
                slidesPerView: 4.5,
            },
            1201:  {
                spaceBetween: 20,
                slidesPerView: 5.5,
            },
            1301:  {
                spaceBetween: 20,
                slidesPerView: 6,
                touchRatio: 0,
                allowTouchMove: false,
            },
        },
    });
};